import { InvariantError } from "./common.ts";

/**
 * `invariant` is used to [assert](https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html#assertion-functions) that the `condition` is [truthy](https://github.com/getify/You-Dont-Know-JS/blob/bdbe570600d4e1107d0b131787903ca1c9ec8140/up%20%26%20going/ch2.md#truthy--falsy).
 *
 * 💥 `invariant` will `throw` an `InvariantError` if the `condition` is [falsey](https://github.com/getify/You-Dont-Know-JS/blob/bdbe570600d4e1107d0b131787903ca1c9ec8140/up%20%26%20going/ch2.md#truthy--falsy)
 * Default error message is "Invariant failed" and explanation is "A logic evaluation failed.". Credits to Alex Reardon for the original implementation.
 * @see {@link InvariantError}
 * @see {@link https://github.com/alexreardon/tiny-invariant}
 * @example
 *
 * ```ts
 * const value: Person | null = { name: 'Alex' };
 * invariant(value, 'Expected value to be a person');
 * // type of `value`` has been narrowed to `Person`
 * ```
 */
export default function invariant(
  condition: any,
  /**
   * Error message for internal use.Can provide a string, or a function that returns a string
   */
  message?: string | (() => string),
  errorProps?: ConstructorParameters<typeof InvariantError>[1]
): asserts condition {
  if (condition) return;

  // When not in production we allow the message to pass through
  // *This block will be removed in production builds*

  const providedMsg: string | undefined =
    typeof message === "function" ? message() : message;

  throw new InvariantError(providedMsg ?? "Invariant failed", errorProps ?? {});
}
